<!--
 * @Author: Yran
 * @Date: 2021-11-25 14:05:26
 * @LastEditors: Yran
 * @LastEditTime: 2021-12-23 10:49:11
-->
<template>
  <div class="hosting-wrapper w100 h100">
    <div v-show="!showCustomizeRule.visible" class="w100 h100" style="padding: 12px">
      <a-tabs v-model:activeKey="activeKey" @change="activeKeyChange">
        <a-tab-pane key="rulesList" tab="规则列表"></a-tab-pane>
        <a-tab-pane key="executionRecord" tab="执行记录" force-render></a-tab-pane>
        <template #tabBarExtraContent>
          <a-button type="primary" style="margin-right: 12px" @click="openAddTempModal"><PlusCircleOutlined />新增规则</a-button>
        </template>
      </a-tabs>
      <hosting-table ref="test"></hosting-table>
    </div>
    <customize-rule v-if="showCustomizeRule.visible"></customize-rule>
    <AddTempModal @getTempData="getTempData"></AddTempModal>
  </div>
</template>

<script>
import CustomizeRule from './components/CustomizeRule.vue';
import HostingTable from './components/HostingTable.vue';
import AddTempModal from './components/AddTempModal.vue';
import { getExecutionTableList, getRulesTableList, deleteRules, saveOrUpdateRules, updateRulesStatus, getAccountOptions, getProductOptions } from '@/api/hosting/index.js';
import { getUserChannel } from '@/api/home/detail.js';
import { PlusCircleOutlined } from '@ant-design/icons-vue';
import { getUserList } from '@/api/hosting/index.js';
export default {
  components: { HostingTable, AddTempModal, CustomizeRule, PlusCircleOutlined },
  provide() {
    return {
      // 选中tab
      getActiveKey: () => this.activeKey,
      showCustomizeRule: this.showCustomizeRule,
      // 是否打开新增规则模板
      addTempVisible: this.addTempVisible,
      // 筛选组件类型
      filterType: 'home',
      // 表格数据
      tableData: this.tableData,
      // 表格配置
      table: this.table,
      // 选中表格行
      getSelectRow: () => this.selectRow,
      // 选中的模板
      getActiveTemp: () => this.activeTemp,
      // 获取表格数据
      getHostTableData: this.getHostTableData,
      // 点击前往执行记录
      toExecutionRecord: this.toExecutionRecord,
      // 编辑自定义托管规则
      editRules: this.editRules,
      // 复制自定义托管规则
      copyRules: this.copyRules,
      // 删除自定义托管规则
      deleteRules: this.deleteRules,
      // 启停自定义托管规则
      updateRulesStatusFun: this.updateRulesStatusFun,
      // 获取用户渠道
      getUserChannel: this.getUserChannel,
      // 获取产品筛选项
      getProductOptions: this.getProductOptionsFun,
      // 账户筛选项
      getAccountOptions: this.getAccountOptionsFun,
      // 所有用户
      getAllUsers: () => this.allUsers,
    };
  },
  computed: {},
  data() {
    return {
      // tab页选中tab
      activeKey: 'rulesList',
      // 是否打开新增规则模板弹窗
      addTempVisible: { visible: false },
      // 记录上一次的筛选
      filterOptions: {},
      showCustomizeRule: {
        visible: false,
        refresh: false,
        mode: 'add',
      },
      //表格数据
      tableData: {
        dataSource: [],
        tableLoading: false,
      },
      // 选中表格行
      selectRow: {},
      // 表格配置
      table: {
        bordered: true,
        size: 'small',
        scroll: { x: 'max-content' },
        showExpanded: false,
        pagination: { current: 1, page: 1, pageSize: 20, total: 0, showTotal: total => `总计${total}条`, showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '50'] },
      },
      // 选中的模板
      activeTemp: {},
      allUsers: [],
    };
  },
  async created() {
    this.getHostTableData();
    await this.getUserList();
  },
  watch: {
    'showCustomizeRule.refresh'(val) {
      if (val) {
        this.getHostTableData();
      }
    },
  },
  methods: {
    /**
     * @description: 获取当前人员的渠道
     * @param {*}
     * @return {*}
     */
    async getUserChannel() {
      let res = await getUserChannel();
      this.$store.commit('SET_USERCHANNEL', this.channel);
      return res.data;
    },
    /**
     * @description: tab页改变
     * @param {*}
     * @return {*}
     */
    activeKeyChange() {
      this.table.pagination.page = 1;
      this.table.pagination.current = 1;
      if (this.activeKey == 'rulesList') {
        this.getHostTableData();
      }
      this.selectRow = {};
    },
    /**
     * @description: 获取自定义托管表格数据
     * @param {*}
     * @return {*}
     */
    async getHostTableData(filterOptions) {
      try {
        filterOptions ? (this.filterOptions = filterOptions) : (filterOptions = this.filterOptions);
        const postData = {
          ...filterOptions,
          // level: this.activeKey,
          limit: this.table.pagination.pageSize,
          page: this.table.pagination.page,
        };
        this.tableData.tableLoading = true;
        // 表格请求接口
        const getUrlList = {
          rulesList: getRulesTableList,
          executionRecord: getExecutionTableList,
        };
        let res = await getUrlList[this.activeKey](postData);
        if (res.code == 0) {
          this.tableData.dataSource = res.data?.list;
          this.tableData.tableLoading = false;
          this.table.pagination.current = res.data?.currPage;
          this.table.pagination.pageSize = res.data?.pageSize;
          this.table.pagination.total = res.data?.totalCount;
        }
      } catch (err) {
        this.tableData.tableLoading = false;
      }
      this.showCustomizeRule.refresh = false;
    },
    /**
     * @description: 点击前往执行记录
     * @param {Object} record 点击的行数据
     * @return {*}
     */
    toExecutionRecord(record) {
      this.selectRow = record;
      this.activeKey = 'executionRecord';
    },
    /**
     * @description: 编辑自定义规则
     * @param {Object} record 点击的行数据
     * @return {*}
     */
    async editRules(record) {
      this.showCustomizeRule.mode = 'edit';
      this.selectRow = record;
      this.getTempData(this.selectRow);
    },
    /**
     * @description: 复制自定义规则
     * @param {Object} record 点击的行数据
     * @return {*}
     */
    async copyRules(record) {
      this.showCustomizeRule.mode = 'copy';
      this.selectRow = record;
      this.getTempData(this.selectRow);
    },
    /**
     * @description: 删除自定义规则
     * @param {Object} record 点击的行数据
     * @return {*}
     */
    async deleteRules(record) {
      this.selectRow = record;
      const postData = [record.id];
      let res = await deleteRules(postData);
      this.getHostTableData();
    },
    /**
     * @description: 启停自定义规则
     * @param {*} record
     * @return {*}
     */
    async updateRulesStatusFun(changed, e, record) {
      this.selectRow = record;
      try {
        const postData = {
          ids: [this.selectRow.id],
          status: changed ? 1 : 0,
        };
        let res = await updateRulesStatus(postData);
        this.$message.success(`规则状态${changed ? '启动' : '停止'}成功！`);
        this.getHostTableData(this.filterOptions);
      } catch (err) {}
    },
    /**
     * @description: 打开新增规则模板弹窗
     * @param {*}
     * @return {*}
     */
    openAddTempModal() {
      // this.addTempVisible.visible = true;
      this.showCustomizeRule.mode = 'add';
      this.showCustomizeRule.visible = true;
    },
    /**
     * @description: 获取从模板创建的模板数据
     * @param {*}
     * @return {*}
     */
    getTempData(temp) {
      this.activeTemp = temp;
      this.addTempVisible.visible = false;
      this.showCustomizeRule.visible = true;
    },
    /**
     * @description: 获取账户筛选项
     * @param {Object} postData 请求参数
     * @return {*}
     */
    async getAccountOptionsFun(postData) {
      let res = await getAccountOptions(postData);
      if (res.code == 0) {
        return (
          res.data?.list?.map(item => ({
            label: item.accountName,
            value: item.accountName,
          })) || []
        );
      }
    },
    /**
     * @description: 获取产品筛选项
     * @param {Object} postData 请求参数
     * @return {*}
     */
    async getProductOptionsFun(postData) {
      let res = await getProductOptions(postData);
      if (res.code == 0) {
        return (
          res.data?.list?.map(item => ({
            label: item.productName,
            value: item.productCode,
          })) || []
        );
      }
    },
    /**
     * @description: 获取创建人筛选项下拉列表
     * @param {*}
     * @return {*}
     */
    async getUserList() {
      const postData = { page: 1, limit: 500 };
      let res = await getUserList(postData);
      if (res.code == 0) {
        res.data?.list?.map(item => {
          item.value = item.userId;
          item.label = item.userCode;
        });
        this.allUsers = res.data?.list || [];
      }
    },
  },
};
</script>

<style lang="less" scoped>
.hosting-wrapper {
  background: #fff;
  border-radius: 8px;
  :deep(.ant-tabs) {
    margin: 0 -12px;
    margin-bottom: 10px;
    padding-left: 36px;
    border-bottom: 2px solid #f5f7fa;
    .ant-tabs-bar {
      margin-bottom: 0px;
      border-bottom: none;
      .ant-tabs-extra-content {
        line-height: 0;
      }
    }
    .ant-tabs-tab {
      padding: 0 5px 12px;
    }
    .ant-tabs-ink-bar {
      height: 3px;
    }
  }
}
</style>